import React from "react";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { resendAdminUserInvite } from "../../../redux/users";
import { capitalizeFirstLetter } from "../../../utils/Helper";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  details?: any;
}

const ResendAdminUserModal = ({
  onClose,
  visible,
  details,
}: myComponentProps) => {
  const { loading_users } = useSelector((state: RootState) => state.users);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const obj = {
      id: details?.id,
    };
    const data = await dispatch(resendAdminUserInvite(obj) as any);

    if (data?.payload?.data?.status) {
      onClose && onClose();
    }
  };

  return (
    <>
      <ReuseModal
        visible={visible}
        onClose={onClose}
        deleteType
        btnColor="black-light"
        btnLabel="Resend Invite"
        title="Resend Team Invite"
        deleteText={`Are you sure you want to resend invite to ${
          capitalizeFirstLetter(details?.first_name) || ""
        } ${
          capitalizeFirstLetter(details?.last_name) || ""
        }  with the email ( ${details?.email || ""} ). `}
        onBtnClick={handleSubmit}
        loading={loading_users}
      />
    </>
  );
};

export default ResendAdminUserModal;
